let swiperInstance = null;

function initSwiperIfNeeded() {
  const isMobile = window.innerWidth < 768;

  if (isMobile && !swiperInstance) {
    swiperInstance = new Swiper('.top__news--slider', {
      slidesPerView: 1.1,
      spaceBetween: 16,
      freeMode: true,
      grabCursor: true,
    });
  } else if (!isMobile && swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }
}

$(document).ready(function () {
  initSwiperIfNeeded();

  // リサイズにも対応
  $(window).on('resize', function () {
    initSwiperIfNeeded();
  });
});

$(function () {
  // モーダルを開く
  $('.top__rewards--link').on('click', function (e) {
    e.preventDefault();
    const targetModalId = $(this).data('modal');
    $('#' + targetModalId).fadeIn();
    $('body').addClass('modal-open'); // ← スクロール禁止
  });

  // モーダルを閉じる
  $('.modal-close, .modal').on('click', function (e) {
    if ($(e.target).hasClass('modal') || $(e.target).hasClass('modal-close')) {
      $(this).closest('.modal').fadeOut();
      $('body').removeClass('modal-open'); // ← スクロール許可
    }
  });
});

$(function () {
  $('.point__use--accordion').on('click', function () {
    const $accordion = $(this);
    const $content = $accordion.next('.point__use--content');

    $content.slideToggle(300);
    $accordion.toggleClass('is-open');
  });
});



